export default __webpack_public_path__ + "static/media/ThinkTimeTable.1febbcd879da66186d74b29bd39b7c33.webp";